import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core';
import { localization } from '../../sc-utilities'
import MaterialTable from 'material-table';
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';



const styles = theme => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(2),
    },

});

const ReportTable = props => {
    const { report, translations } = props;

    let reportData = report && report.loaded ? report.loaded : null;
    const [columns, setColumns] = useState([{ title: translations["username"] || 'Username', field: 'UserName', }, { title: translations["total"] || 'Total', field: 'Total', }]);

    useEffect(() => {
        setColumns([{ title: translations["username"] || 'Username', field: 'UserName', }, { title: translations["total"] || 'Total', field: 'Total', }])
        return () => {

        };
    }, [report, translations])
    let array = []
    let obj = {}

    if (reportData) {
        for (let i = 0; i < Object.keys(reportData).length; i++) {
            if (Object.keys(reportData)[i] !== 'undefined') { array.push({ ...reportData[Object.keys(reportData)[i]], UserName: Object.keys(reportData)[i] }) };
        };
    };
    let pageSizeArray = array && array.length > 0 && array.length < 5 ? [20, 10] : array.length > 10 && array.length < 20 ? [20, 10, array.length] : array.length > 20 && array.length < 50 ? [20, 10, 20, 50] : array.length > 50 ? [20, 10, 20, 50, array.length] : [];

    var tableOptions = {
        exportFileName: `securaze_report_statistic_${Math.floor(Date.now() / 500)}`,
        exportButton: false,
        columnsButton: true,
        search: false,
        paging: true,
        pageSize: array.length > 5 ? 10 : 5,
        pageSizeOptions: pageSizeArray,
    };

    let filterList = array.map(user => {

        obj = Object.entries(user).length === 0 && obj.constructor === Object ? null : { ...user };
        return obj;
    });



    const dragged = (oldPos, newPos) => {
    };

    return (<>
        <MaterialTable
            columns={columns}
            borderBottom={0}
            search={false}
            onColumnDragged={dragged}
            title={''}
            style={{ overflow: 'auto', maxHeight: '662px', marginRight: '5px' }}
            data={filterList}
            localization={localization(translations)}
            options={tableOptions}
            icons={{
                Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
                Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
                Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
                Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
                DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
                Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
                Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
                Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
                FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
                LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
                NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
                PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
                ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
                Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
                SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
                ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
                ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
            }}
        />

    </>
    );
};

export default withStyles(styles, { withTheme: true })(ReportTable);